"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function autoEllipsis(container, textNode, premitiveText) {
  var str = premitiveText;
  textNode.textContent = str;
  container.style.whiteSpace = 'nowrap';
  container.style.width = 'fit-content';
  var containerWidth = container.clientWidth;

  if (containerWidth >= textNode.offsetWidth) {
    textNode.textContent = str;
    return;
  } else {
    var textWidth = textNode.offsetWidth;
    var strNumer = str.length;
    var avgStrWidth = textWidth / strNumer;
    var canFitStrNumber = Math.floor(containerWidth / avgStrWidth);
    var shouldDelNumber = strNumer - canFitStrNumber + 1.5;
    var delEachSide = shouldDelNumber / 2;
    var endLeft = Math.floor(strNumer / 2 - delEachSide);
    var startRight = Math.ceil(strNumer / 2 + delEachSide);
    textNode.textContent = str.slice(0, endLeft - 3) + '...' + str.slice(startRight);
    container.style.wordBreak = 'break-all';
  }
}

function AutoEllipsis(props) {
  var text = props.text,
      onClick = props.onClick,
      className = props.className;
  var containerRef = (0, _react.useRef)();
  var textRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (containerRef.current && textRef.current) {
      autoEllipsis(containerRef.current, textRef.current, text);
    }
  }, [text]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick,
    className: className,
    ref: containerRef
  }, /*#__PURE__*/_react["default"].createElement("span", {
    ref: textRef
  }, text));
}

var _default = AutoEllipsis;
exports["default"] = _default;
//# sourceMappingURL=AutoEllipsis.js.map